import { render, staticRenderFns } from "./eloadForm.vue?vue&type=template&id=0b2d96b4&scoped=true"
import script from "./eloadForm.vue?vue&type=script&lang=js"
export * from "./eloadForm.vue?vue&type=script&lang=js"
import style0 from "./eloadForm.vue?vue&type=style&index=0&id=0b2d96b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2d96b4",
  null
  
)

export default component.exports